import {
    NinchatActionType,
    NinchatUpdateRealmAction,
} from '../types/actions'
import ninchatClient, {
    NinchatActionParams,
} from '../NinchatClient'
import {createAsyncThunk} from '@reduxjs/toolkit'

const actionTypePrefix = 'NINCHAT/action'

export const updateRealm = createAsyncThunk(
    `${actionTypePrefix}/${NinchatActionType.NinchatUpdateRealmAction}`,
    async (arg: NinchatActionParams<NinchatUpdateRealmAction>, {rejectWithValue}) => {
        const {...params} = arg

        params.action = NinchatActionType.NinchatUpdateRealmAction

        try {
            return await ninchatClient.send(params)
        } catch (err) {
            return rejectWithValue(err)
        }
    },
)
